
import {Ticket} from "@/models/ticket";
import {TicketMessage} from "@/models/ticket-message";
import {TicketService} from "@/services/ticket-service";
import Vue from "vue";

export default Vue.extend({
	props: {
		ticket: {
			type: Object as () => Ticket,
			required: true
		},
		message: {
			type: Object as () => TicketMessage,
			required: true
		}
	},
	computed: {
		checked(): boolean {
			return this.message.isLiked();
		},
		iconPrefix(): string {
			if (this.checked) {
				return "fas";
			}
			return "far";
		},
		tooltip(): string {
			return this.message.likes.map((u) => {
				return u.getAdminName();
			}).join();
		},
		likeCount(): number {
			return this.message.likes.length;
		}
	},
	methods: {
		async onClick() {
			return false;
			if (!this.checked) {
				await TicketService.like(this.ticket, this.message);
			} else {
				await TicketService.unlike(this.ticket, this.message);
			}
		}
	},
	async created() {

	}
});
